import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, TextField, Typography, Paper, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function UserInfoTab({ user }) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';

  const registerFromText =
    user?.registerFrom === 'SaudiProjects'
      ? t('users.saudiProjects') || 'مشاريع السعودية'
      : t('users.maskeen') || 'مساكن';

  const isVerified = user?.isVerified === '1' || user?.isVerified === 1 || user?.status === '1' || user?.status === 1;

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, md: 3 },
        borderRadius: '16px',
        border: '1px solid #E5E8EB',
        backgroundColor: '#fff',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {t('users.userInfo') || 'معلومات المستخدم'}
        </Typography>
        {user?.isVerified !== undefined && (
          <Chip
            label={isVerified ? t('users.verfied') : t('users.unverfied')}
            sx={{
              backgroundColor: isVerified ? '#E7F7EF' : '#FFEDEC',
              color: isVerified ? '#0CAF60' : '#E03137',
              fontWeight: 700,
              fontSize: '12px',
              borderRadius: '8px',
            }}
          />
        )}
      </Box>

      <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
        <Grid item xs={4} sm={4} md={6}>
          <Typography variant="subtitle2" sx={{ mb: 1, color: '#637381', textAlign: isRtl ? 'right' : 'left' }}>
            {t('users.userName')}
          </Typography>
          <TextField
            fullWidth
            disabled
            value={user?.fullName || ''}
            variant="outlined"
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: '#212B36',
              },
            }}
          />
        </Grid>

        <Grid item xs={4} sm={4} md={6}>
          <Typography variant="subtitle2" sx={{ mb: 1, color: '#637381', textAlign: isRtl ? 'right' : 'left' }}>
            {t('users.userEmail')}
          </Typography>
          <TextField
            fullWidth
            disabled
            value={user?.email || ''}
            variant="outlined"
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: '#212B36',
              },
            }}
          />
        </Grid>

        <Grid item xs={4} sm={4} md={6}>
          <Typography variant="subtitle2" sx={{ mb: 1, color: '#637381', textAlign: isRtl ? 'right' : 'left' }}>
            {t('users.phoneNumber')}
          </Typography>
          <TextField
            fullWidth
            disabled
            value={user?.phone || ''}
            variant="outlined"
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: '#212B36',
              },
            }}
          />
        </Grid>

        <Grid item xs={4} sm={4} md={6}>
          <Typography variant="subtitle2" sx={{ mb: 1, color: '#637381', textAlign: isRtl ? 'right' : 'left' }}>
            {t('users.dateOfBirth')}
          </Typography>
          <TextField
            fullWidth
            disabled
            value={user?.birthDate || ''}
            variant="outlined"
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: '#212B36',
              },
            }}
          />
        </Grid>

        <Grid item xs={4} sm={4} md={6}>
          <Typography variant="subtitle2" sx={{ mb: 1, color: '#637381', textAlign: isRtl ? 'right' : 'left' }}>
            {t('users.registerFrom') || 'مصدر التسجيل'}
          </Typography>
          <TextField
            fullWidth
            disabled
            value={registerFromText}
            variant="outlined"
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: '#212B36',
              },
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

UserInfoTab.propTypes = {
  user: PropTypes.object,
};
